import IReader from './IReader'
import GMLBean from '../beans/GMLBean'

/**
 * 读取Shp文件
 */
export default class GMLReader extends IReader {
    constructor() {
        super(GMLBean)

        this._format = new GeoGlobe.Format.GML()
        this._format1 = new GeoGlobe.Format.JSON()
        this._format2 = new GeoGlobe.Format.GeoJSON()
    }

    /**
     * 读取GML文件
     * @param {GMLBean} GMLBean
     */
    async _read(GMLBean) {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.onload = function() {
                resolve(fileReader.result)
            }
            fileReader.onerror = reject
            fileReader.readAsText(GMLBean.file)
        })
        return promise.then(result => {
            const features = this._format.read(result)
            const gjStr = this._format2.write(features)
            const gjObj = this._format1.read(gjStr)
            return gjObj.features
        })
    }
}
